import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { PlayCircle } from "lucide-react";

interface DemoModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const DemoModal = ({ open, onOpenChange }: DemoModalProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-3xl">
        <DialogHeader>
          <DialogTitle>Watch a 60-second demo</DialogTitle>
        </DialogHeader>
        <div className="aspect-video w-full rounded-md bg-muted flex flex-col items-center justify-center text-muted-foreground">
          <PlayCircle className="h-16 w-16 mb-3 opacity-60" />
          <p className="text-sm">Demo video coming soon.</p>
          <p className="text-xs mt-1">
            We'll drop in the Loom once the MCP server is live.
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default DemoModal;
